var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.2 238.2",
    style: {
      enableBackground: "new 0 0 188.2 238.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:#D177B8;}\n\t.st2{fill:url(#SVGID_00000081629719181723319740000012555426252294775455_);}\n\t.st3{opacity:0.6;fill:url(#SVGID_00000043436603621459347240000018257706593919224980_);}\n\t.st4{opacity:0.6;fill:url(#SVGID_00000136386748091516276840000014283224590438870955_);}\n\t.st5{fill:url(#SVGID_00000180330935723964853100000006032046261802949553_);}\n\t.st6{opacity:0.6;fill:url(#SVGID_00000005252743446603518970000006480681069962570409_);}\n\t.st7{opacity:0.6;fill:url(#SVGID_00000045607374120121414710000014629377265745214857_);}\n\t.st8{fill:#DD6B7C;}\n\t.st9{fill:url(#SVGID_00000125561023356989751520000012875066447495681709_);}\n\t.st10{opacity:0.6;fill:url(#SVGID_00000146460075712141167580000015819077604299594172_);}\n\t.st11{opacity:0.6;fill:url(#SVGID_00000168825747943514360930000016114511622036747909_);}\n\t.st12{fill:url(#SVGID_00000081642449564742674310000010194202656785205932_);}\n\t.st13{display:none;opacity:0.5;}\n\t.st14{display:inline;fill:#E76965;}\n\t.st15{opacity:0.6;fill:url(#SVGID_00000181796320090833867910000014455118769902326688_);}\n\t.st16{opacity:0.6;fill:url(#SVGID_00000083790402561678679770000005217342062154378380_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.3906,
    y1: 238.1652,
    x2: 95.3906,
    y2: 174.9486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.4,216.6c-1-6.6,0-41.6,0-41.6l-28,1.8l-28-1.8c0,0,1,35,0,41.6c0,0-15.8,16.9-42.8,21.6h70.8h70.8 C139.2,233.4,123.4,216.6,123.4,216.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.8,194.8c0,0,24.5,21.1,55.2,12.3l0.4-32.1c0,0-16.2,11.5-56,1.6L67.8,194.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090985454525231363050000001014208540345813920_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.0608,
    y1: 238.17,
    x2: 95.0608,
    y2: 214.9379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC5E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090985454525231363050000001014208540345813920_)"
    },
    d: "M170,238.2H20.1c0,0,26-8.2,30.8-12.4 c1.1-1,2.2-2.2,3.2-3.3c1.7-2,3.1-4,4.1-5.4l0.1-0.1c0.8-1.1,1.3-1.9,1.4-1.9c0.4-0.2,7.4,1.5,7.8,1.6l0,0l-3.5,3.2 c0,0,8.1,12.1,31.5,12.1c15.7,0,24.1-5.7,28-9.5v0c1.9-1.9,2.7-3.3,2.7-3.3l-2.7-2.6l7.9-1.6c0,0,0.3,1.8,1.3,4.2 c0.6,1.3,1.3,2.8,2.4,4.2c0.9,1.2,1.9,2.3,3.2,3.2C143.7,230.4,170,238.2,170,238.2z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.3,214.9l-7.9,7.5v0c1.9-1.9,2.7-3.3,2.7-3.3l-2.7-2.6L131.3,214.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.4,216.6l-3.5,3.2l-4.3-4.8C59.9,214.8,66.9,216.5,67.4,216.6L67.4,216.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096767262732298851760000004871565485567906209_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0456,
    y1: 227.5316,
    x2: 85.5848,
    y2: 227.5316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00558659,
    style: {
      stopColor: "#D177F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000096767262732298851760000004871565485567906209_)"
    },
    d: "M58.2,216.9 c0,0-0.8,7,9.2,14.7c7.6,5.9,18.2,6.6,18.2,6.6s-18.9-0.4-31.5-15.7L58.2,216.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000909950217623270950000014752143426112344724_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.9475,
    y1: 227.4001,
    x2: 135.0043,
    y2: 227.4001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000000909950217623270950000014752143426112344724_)"
    },
    d: "M132.6,219.1 c0,0-5.7,11.8-17.7,16.6c0,0,15.2-3.1,20.1-12.4L132.6,219.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003798476566832958540000011163292883577929125_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.5699,
    y1: 133.8593,
    x2: 174.5699,
    y2: 78.6916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003798476566832958540000011163292883577929125_)"
    },
    d: "M187.2,104.1c-0.4,1.8-0.8,3.4-1.2,4.9 c0,0,0,0,0,0.1c-3.2,10.3-8.1,12.8-10,17.5c-1.7,4-8.4,12.1-15,3.7c0,0,0,0,0,0s3.1-34.3,5.7-40.5c0,0,3.6-9.3,10.2-10.8 C185.2,77.1,190.5,88.1,187.2,104.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173143695389826074150000003748407122456976307_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.5838,
    y1: 124.4153,
    x2: 174.5838,
    y2: 88.4473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000173143695389826074150000003748407122456976307_)"
    },
    d: "M163.2,108.9 c0,0,13.2-19.1,19.5-20.4c6.3-1.3,3.1,15,1.9,20.4c-1.3,5.4-3.2,8.6-3.2,8.6s1.6-6.4,1.9-11.5c0.4-7.4-1.9-13.8-4.6-13.2 c-2.6,0.6-6.2,9.9-6.4,11c-0.2,1.1,1.8,3,1.6,8.7c-0.1,5.8-2.9,12-4.4,11.9c-1.5-0.1-0.9-4.7-0.9-10.1c0-5.4-4.2-4.3-6.1-0.8 L163.2,108.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091725152895552141310000012389790962586581181_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.0946,
    y1: 120.2837,
    x2: 168.0946,
    y2: 102.6518
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000091725152895552141310000012389790962586581181_)"
    },
    d: "M162.7,113.5 c0,0,3.4-5.1,5.4-2.8c2,2.3,0.6,8.8,2.1,9.6c1.6,0.8,3.6-4.4,3.2-9.2s-2.3-9-5-8.2l-5.2,6.1L162.7,113.5z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M186,109c-3.2,10.3-8.1,12.8-10,17.5c-1.7,4-8.4,12.1-15,3.7c0.4,0.3,4.2,3.4,8.1,2c4.1-1.5,5.4-5.3,7.1-8.3 C177.9,121,182.3,119,186,109z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095331346639659523900000013182963653067362951_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.9762,
    y1: 133.8593,
    x2: 132.9762,
    y2: 78.6916,
    gradientTransform: "matrix(-1 0 0 1 146.6073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095331346639659523900000013182963653067362951_)"
    },
    d: "M1,104.1c0.4,1.8,0.8,3.4,1.2,4.9 c0,0,0,0,0,0.1c3.2,10.3,8.1,12.8,10,17.5c1.7,4,8.4,12.1,15,3.7c0,0,0,0,0,0s-3.1-34.3-5.7-40.5c0,0-3.6-9.3-10.2-10.8 C3,77.1-2.3,88.1,1,104.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111878817888116082610000014997930410379172776_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.9901,
    y1: 124.4153,
    x2: 132.9901,
    y2: 88.4473,
    gradientTransform: "matrix(-1 0 0 1 146.6073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000111878817888116082610000014997930410379172776_)"
    },
    d: "M25,108.9 c0,0-13.2-19.1-19.5-20.4s-3.1,15-1.9,20.4c1.3,5.4,3.2,8.6,3.2,8.6s-1.6-6.4-1.9-11.5c-0.4-7.4,1.9-13.8,4.6-13.2 c2.6,0.6,6.2,9.9,6.4,11c0.2,1.1-1.8,3-1.6,8.7s2.9,12,4.4,11.9c1.5-0.1,0.9-4.7,0.9-10.1c0-5.4,4.2-4.3,6.1-0.8L25,108.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135664074229618729040000002135797977993643395_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.501,
    y1: 120.2837,
    x2: 126.501,
    y2: 102.6518,
    gradientTransform: "matrix(-1 0 0 1 146.6073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000135664074229618729040000002135797977993643395_)"
    },
    d: "M25.5,113.5 c0,0-3.4-5.1-5.4-2.8c-2,2.3-0.6,8.8-2.1,9.6c-1.6,0.8-3.6-4.4-3.2-9.2c0.4-4.8,2.3-9,5-8.2l5.2,6.1L25.5,113.5z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.2,109c3.2,10.3,8.1,12.8,10,17.5c1.7,4,8.4,12.1,15,3.7c-0.4,0.3-4.2,3.4-8.1,2c-4.1-1.5-5.4-5.3-7.1-8.3 C10.3,121,5.9,119,2.2,109z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181771847959431556170000000622526935730267304_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.0756,
    y1: 182.3999,
    x2: 94.0756,
    y2: -9.094947e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAA96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4274,
    style: {
      stopColor: "#F9AB99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#FBA38F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FE9983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF967F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181771847959431556170000000622526935730267304_)"
    },
    d: "M163.9,118c0,0.2-0.1,0.5-0.2,0.9 c-1.7,9.2-3.4,16.9-4.9,21.6c-5.7,18.2-35,41.9-64.8,41.9c-29.8,0-59.1-23.8-64.8-41.9c-0.7-2.1-1.4-4.9-2.2-8.2 c-2.7-11.5-5.7-29.1-7.5-46.4c0,0,0,0,0,0c-2-19.6-2.4-38.6,1.1-47.7c2.5-6.4,8.6-13.8,17.6-20.4v0C51.7,7.9,71.2,0,94.1,0 c38.3,0,67.2,22.3,73.3,38.1C172.9,52.5,168.8,91.2,163.9,118z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M59,131.2c-0.3,0.3-0.6,0.6-0.6,1c0,0.3,0,0.6,0.2,0.9c0.4,0.4,1,0.6,1.5,0.7c0.6,0.2,1.2-0.1,1.6-0.5 c0.4-0.4,0.6-1,0.7-1.5c0.1-0.5,0-1.2-0.3-1.6c-0.1-0.2-0.4-0.4-0.5-0.5c-0.2-0.1-0.6-0.2-0.8-0.2c-0.3,0-0.6,0.3-0.8,0.5 c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.3,0.2-0.4,0.4c-0.2,0.2-0.2,0.5-0.3,0.8L59,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M68.3,125.8c0.4,0,1.1,0.1,1.5-0.1c0.2-0.1,0.4-0.3,0.7-0.4c0.2-0.1,0.5-0.2,0.6-0.4 c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.3-0.4,0.8-1.7-0.1-1.7c-0.4,0-1,0.2-1.3,0.5c-0.3,0.3-0.6,0.5-0.9,0.8 C68.8,124.4,68.6,125.1,68.3,125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M69.8,127.6c0.3-0.2,0.5-0.4,0.8-0.2c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.3-0.2,0.7-0.5,0.7 c-0.3,0-0.6,0-0.7-0.3c-0.1-0.1-0.1-0.2,0-0.4C69.6,127.8,69.8,127.7,69.8,127.6L69.8,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M76.2,118.1c-0.3,0.3-0.4,0.4-0.1,0.6c0.3,0.2,0.7,0.1,1-0.1c0.7-0.4,1.2-1,0.8-1.8 c-0.3-0.5-0.9-0.5-1.3-0.1c-0.5,0.5-0.6,1.2-0.6,1.9L76.2,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.5,117.4c-0.2,0.1-0.4,0.2-0.5,0.4c0,0.2,0,0.3,0.2,0.3c0.2,0,0.6-0.1,0.7-0.3c0.1-0.1,0-0.4,0-0.5 c-0.2-0.3-0.5-0.1-0.7,0.1L80.5,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M87.8,113.7c0.1-0.2,0.1-0.3,0.4-0.4c0.2-0.1,0.4-0.1,0.7-0.1c0.4,0,0.7,0.2,0.9,0.6c0.2,0.3,0,0.6-0.2,0.9 c-0.3,0.5-0.8,0.7-1.3,0.9c-0.5,0.2-1.8,0.5-1.7-0.4c0-0.4,0.3-0.7,0.6-0.9c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.2-0.2 H87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M95.4,114.6c-0.1,0.3-0.1,0.3,0.1,0.4c0.2,0.1,0.5,0.2,0.7,0.1c0.2-0.1,0.5-0.3,0.5-0.6 c0-0.3-0.3-0.4-0.6-0.4C95.9,114.2,95.5,114.4,95.4,114.6L95.4,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M109.4,116c0,0.5,0.3,0.8,0.7,1c0.4,0.2,0.9,0.3,1.4,0.1c0.6-0.3,0.4-0.9,0.2-1.4c-0.1-0.3-0.2-0.6-0.4-0.8 c-0.2-0.3-0.4-0.5-0.7-0.7c-0.5-0.3-1.5-0.4-1.5,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0.1,0.2,0.1,0.3C109.2,115.5,109.3,115.7,109.4,116 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M111.5,118.9c0-0.2,0-0.3,0.2-0.4c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0.1,0.3,0.4,0.3,0.6c0,0.2-0.2,0.2-0.4,0.2 c-0.1,0-0.2-0.1-0.3-0.1C111.6,119.1,111.6,119,111.5,118.9L111.5,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M42.8,128.4c-0.1,0.4-0.2,0.8,0.2,1c0.5,0.4,1.1,0.3,1.6,0.4c0.7,0.1,1.9,0,2-0.9c0-0.2-0.1-0.2-0.2-0.4 c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-0.7-0.2c-0.5-0.1-0.9,0-1.3,0.1 C43,127.7,42.6,127.9,42.8,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M35.9,117.7c-0.1,0.2-0.1,0.3,0.1,0.4c0.3,0.2,0.5,0.2,0.8,0.2c0.3,0,0.7-0.1,0.4-0.4 c-0.2-0.2-0.3-0.3-0.6-0.5c-0.1,0-0.2-0.1-0.3-0.1C36.1,117.3,36,117.6,35.9,117.7L35.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M101.2,117.5c0.3,1,0.7,1.4,1.7,1.7c0.6,0.2,1.1,0.3,1.6,0c1-0.6,0.3-2.1-0.4-2.6c-0.5-0.4-1.2-0.6-1.8-0.9 c-0.4-0.2-0.8-0.4-1.3-0.1c-0.8,0.5-0.2,1.5,0,2.1L101.2,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M141.3,123.2c0.4,0.6,0.3,0.6,0.7,0.8c0.5,0.1,1.1,0.2,1.5,0.2c0.8-0.1,1.9-0.5,2.6-0.9 c1-0.6,1.3-2.1,0.1-2.6c-1.1-0.5-2.7-0.4-3.7,0.3c-0.4,0.3-1,0.7-1.3,1.2c-0.5,0.8-0.4,1.3,0.2,2L141.3,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M151.8,118.8c0.3-0.5,0.3-0.8,0.8-0.7c0.2,0,0.4,0.2,0.6,0.3c0.4,0.4,0.6,0.9,0.1,1.3 c-0.3,0.2-0.8,0.3-1.1,0.2c-0.5-0.1-0.5-0.5-0.5-1L151.8,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M118.2,127.5c0.8,0.8,1.9,2.4,3.2,2.3c1.2,0,1.8-1.5,1.3-2.5c-0.5-0.9-1.5-1.6-2.5-1.7 c-0.4-0.1-1-0.1-1.4,0.2c-1,0.5-0.6,1.9-0.1,2.7L118.2,127.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M123.5,124.1c0.7,0,1.3-0.2,1.9-0.4c-0.3-0.2-0.5-0.5-0.8-0.7c-0.3-0.1-0.8-0.1-1.1,0 C122.9,123.2,122.3,124.1,123.5,124.1L123.5,124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M140.4,125.4c-0.4,0.5-0.6,0.6-0.5,1.1c0.1,0.3,0.2,0.6,0.5,0.8c0.4,0.3,1.1,0.3,1.3-0.2 c0.4-0.8-0.3-1.7-1.2-1.5c0,0.1,0,0.1,0,0.2V125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M91.5,107.2c0.7,0.1,1.3,0.4,1.8,0.8c-0.2,0.6-0.8,0.9-1.4,0.7c-0.4-0.1-1.3-0.9-0.7-1.3L91.5,107.2z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.7,118.9c-1.7,9.2-3.4,16.9-4.9,21.6c-5.7,18.2-35,41.9-64.8,41.9c-29.8,0-59.1-23.8-64.8-41.9 c-0.7-2.1-1.4-4.9-2.2-8.2l0.1-2.1c0,0,1.1,10.7,10.2,22.8c9.1,12.1,33.2,26.5,56.6,26.5c23.4,0,48.7-17.6,57.1-27.8 C158.6,142.9,162.8,123.6,163.7,118.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007399183183351499930000014689795949908926365_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.2621,
    y1: 85.87,
    x2: 28.2621,
    y2: 17.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000007399183183351499930000014689795949908926365_)"
    },
    d: "M33.5,63.1 C30.9,72.2,20,85.4,19.7,85.9c-2-19.6-2.4-38.6,1.1-47.7c2.5-6.4,8.6-13.8,17.6-20.4C30.7,31.3,36.2,53.8,33.5,63.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032616003552544817070000002591065358446813327_",
    gradientUnits: "userSpaceOnUse",
    x1: 538.0362,
    y1: 85.87,
    x2: 538.0362,
    y2: 17.73,
    gradientTransform: "matrix(-1 0 0 1 697.9252 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#D177F4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000032616003552544817070000002591065358446813327_)"
    },
    d: "M154.6,63.1 c2.6,9.1,13.5,22.4,13.9,22.8c2-19.6,2.4-38.6-1.1-47.7c-2.5-6.4-8.6-13.8-17.6-20.4C157.4,31.3,152,53.8,154.6,63.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarHead);
export default __webpack_public_path__ + "static/media/AvatarHead.71de29cb8a1c1f4e13c01ae0ac323c59.svg";
export { ForwardRef as ReactComponent };